import { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";

import { getMembers } from "../../services/memberService";
import { getTrainers } from "../../services/trainerService";
import { getPayments } from "../../services/paymentService";

// import { exportMembersExcel } from "../../utils/exportMembersExcel";
import { exportMembersPDF } from "../../utils/exportMembersPDF";
// import { exportPaymentsPDF } from "../../utils/exportPaymentsPDF";
import { getSettings } from "../../services/settingsService";
import { exportBusinessReport } from "../../utils/exportBusinessReport";

import "./Reports.css";

export default function Reports() {
  const [report, setReport] = useState({
    totalMembers: 0,
    activeMembers: 0,
    expiredMembers: 0,
    totalTrainers: 0,
    totalRevenue: 0,
    pendingPayments: 0,
  });
  const [members, setMembers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [gym, setGym] = useState(null);
  useEffect(() => {
    loadMembers();
    loadPayments();
    loadGym();
    loadReports();
  }, []);

  const loadGym = async () => {
    try {
      const data = await getSettings();
      setGym(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadPayments = async () => {
    const data = await getPayments();
    setPayments(data);
  };

  const loadMembers = async () => {
    try {
      const data = await getMembers();
      setMembers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadReports = async () => {
    const members = await getMembers();
    const trainers = await getTrainers();
    const payments = await getPayments();

    const activeMembers = members.filter(
      (member) => new Date(member.expiryDate) >= new Date(),
    ).length;

    const expiredMembers = members.length - activeMembers;

    const totalRevenue = payments
      .filter((payment) => payment.status === "Paid")
      .reduce((sum, payment) => sum + Number(payment.amount), 0);

    const pendingPayments = payments
      .filter((payment) => payment.status === "Pending")
      .reduce((sum, payment) => sum + Number(payment.amount), 0);

    setReport({
      totalMembers: members.length,
      activeMembers,
      expiredMembers,
      totalTrainers: trainers.length,
      totalRevenue,
      pendingPayments,
    });
  };

  return (
    <DashboardLayout>
      <div className="reports-header">
        <div>
          <h1>Reports & Analytics</h1>
          <p style={{ fontWeight: "bold", color: "white" }}>
            Track members, trainers, revenue and business performance insights.
          </p>
        </div>

        <div className="report-badge">Live Analytics</div>
      </div>

      <div className="report-grid">
        <div className="report-card">
          <h3>Total Members</h3>
          <p>{report.totalMembers}</p>
        </div>

        <div className="report-card">
          <h3>Active Members</h3>
          <p>{report.activeMembers}</p>
        </div>

        <div className="report-card">
          <h3>Expired Members</h3>
          <p>{report.expiredMembers}</p>
        </div>

        <div className="report-card">
          <h3>Total Trainers</h3>
          <p>{report.totalTrainers}</p>
        </div>

        <div className="report-card">
          <h3>Total Revenue</h3>
          <p>₹{report.totalRevenue}</p>
        </div>

        <div className="report-card">
          <h3>Pending Payments</h3>
          <p>₹{report.pendingPayments}</p>
        </div>

        <div className="report-actions">
          {/* <button
            className="export-btn"
            onClick={() => exportMembersExcel(members, gym)}
          >
            Export Members Excel
          </button> */}
          <button
            className="export-btn"
            onClick={() => exportMembersPDF(members, gym)}
          >
            Export Members PDF
          </button>

          <button
            className="export-btn"
            onClick={() => exportBusinessReport(members, payments, report, gym)}
          >
            Business Report PDF
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
